import React, { useState, useEffect } from "react"
import styled from "styled-components"
import { Theme, Button } from "@pga/pga-component-library"
import { StyledModal } from "./StyledModal"
import { useModal } from "./ModalContext"
import { withRouter } from "react-router-dom"
import { gql, useQuery } from "@apollo/client"
import qs from "qs"
import { COACH_TOOLS_API } from "../../../apolloClient"
import { BACKGROUND_CHECK_ORDER_FRAGMENT } from "../../../utils/prospect/withProspectQuery"
import { isStaffInvitationReady } from "../../../utils/prospect/backgroundCheckCta"
import Step1 from "../../widgets/Prospect/StatusTracker/BackgroundCheckSteps/Step1"
import Step2 from "../../widgets/Prospect/StatusTracker/BackgroundCheckSteps/Step2"
import Step3 from "../../widgets/Prospect/StatusTracker/BackgroundCheckSteps/Step3"

export const BACKGROUND_CHECK_ORDER_QUERY = gql`
  query ProspectQuery {
    currentMember {
      prospect {
        backgroundCheckOrder {
          ${BACKGROUND_CHECK_ORDER_FRAGMENT}
        }
      }
    }
  }
`

export const Btn = styled(Button)`
  padding: 5px;
  margin-right: 10px;
  min-height: 42px;
  min-width: 135px;
  border: 1px solid ${Theme.colors.lightBlue};
  @media screen and (max-width: 575.98px) {
    margin-bottom: 10px;
  }
`

const BackgroundCheckModal = ({ history }) => {
  const { activeModal, closeModal } = useModal()
  const [step, setStep] = useState(1)
  const { backgroundCheckConfirmation } = qs.parse(window.location.search, {
    ignoreQueryPrefix: true,
  })

  const { data } = useQuery(BACKGROUND_CHECK_ORDER_QUERY, {
    context: { api: COACH_TOOLS_API },
  })

  const order = data?.currentMember?.prospect?.backgroundCheckOrder
  const staffInvitationReady = isStaffInvitationReady(order)

  useEffect(() => {
    if (backgroundCheckConfirmation) {
      setStep(3)
    }
  }, [backgroundCheckConfirmation])

  useEffect(() => {
    if (staffInvitationReady || order?.paidAt) {
      setStep(3)
    }
  }, [staffInvitationReady, order?.paidAt])

  const handleClose = () => {
    closeModal()
    if (step === 2) {
      setStep(1)
    }
  }

  const monitorOrderStatus =
    !order?.awaitingModeration && (staffInvitationReady || !!order?.paidAt)

  useQuery(BACKGROUND_CHECK_ORDER_QUERY, {
    context: { api: COACH_TOOLS_API },
    skip: !monitorOrderStatus,
    pollInterval: 5000,
  })

  if (activeModal !== "backgroundCheck" || order?.awaitingModeration)
    return null

  const steps = [
    {
      primaryAction: {
        label: "Purchase Background Check",
        handler: () => setStep(2),
      },
      title: "Your PGA of America Background Check",
      component: Step1,
    },
    {
      title: "Payment",
      component: Step2,
    },
    {
      title: staffInvitationReady
        ? "Continue Your Background Check"
        : "Start Your Background Check",
      component: Step3,
      handler: handleClose,
    },
  ]

  const activeStepIndex = staffInvitationReady || order?.paidAt ? 2 : step - 1
  const {
    primaryAction,
    title,
    component: StepComponent,
    handler: stepHandler,
  } = steps[activeStepIndex]

  const {
    handler: handlePrimaryAction,
    label: primaryActionLabel,
    outline: primaryActionOutline,
  } = primaryAction || {}

  return (
    <StyledModal
      isOpen
      onClose={handleClose}
      data-testid="background-check-modal"
      title={title}
      closeButton
    >
      <StepComponent order={order} onClose={stepHandler} />
      {primaryAction && !staffInvitationReady && !order?.paidAt && (
        <div style={{ marginTop: "20px", textAlign: "center" }}>
          <Btn onClick={handlePrimaryAction} outline={primaryActionOutline}>
            {primaryActionLabel}
          </Btn>
        </div>
      )}
    </StyledModal>
  )
}

export default withRouter(BackgroundCheckModal)
